export function asHubHttpApolloError(error) {
  return error && error;
}